import React, { useEffect, useState } from "react";

import { BrowserRouter as Router } from "react-router-dom";
import { message, Table } from "antd";
import './antd.css';
import "./styles.css";
import "./accessibility.css";
import SiteRouter from "./utils/SiteRouter";
import { apiCall } from "./utils/Api";
import Session, { useSession } from "./utils/Session";
import Cookies from 'js-cookie';

export default function Tbm() {



    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);
    const sitesettings = window.sitesettings;


    const getSettings = () => {
        apiCall("store/getSettings", { "store_id": 298 }, (_s, _r) => {
            if (_s) {
                window.sitesettings = _r;
                getSession();
            } else {
                message.error(_r.error);
            }
        })
    }

    const getSession = () => {
        apiCall("session/get", {}, (_s, _r) => {
            if (_s) {
                Cookies.set("session_id", _r.session_id, { expires: 365 });
                console.log(_r)
                setSession(_r);
                setLoading(false);
            } else {
                message.error(_r.error);
            }
        })
    }

    useEffect(getSettings, []);



  


    if (loading) {
        return (<>loading...</>)
    }

    return (
        <Session value={[session, setSession]}>
            <Router>
                <SiteRouter sitesettings={sitesettings} />
            </Router>
        </Session>
    )
}